import localforage from "localforage";
import { defaultErrorCallback } from "./callbacks-utils";

export const clearIndexedDB = (errorCallback = defaultErrorCallback) =>
  new Promise(resolve => {
    localforage
      .clear()
      .then(function () {
        resolve(true);
      })
      .catch(error => {
        errorCallback(error);
        resolve(false);
      });
  });

export const getAllFilesFromIndexedDB = (
  errorCallback = defaultErrorCallback
) =>
  new Promise(resolve => {
    const filesWithKey = {};

    localforage
      .iterate((value, key) => {
        filesWithKey[key] = value;
      })
      .then(() => {
        resolve(filesWithKey);
      })
      .catch(error => {
        errorCallback(error);
        resolve({});
      });
  });

export const removeItemFromIndexedDB = (
  itemKey,
  errorCallback = defaultErrorCallback
) =>
  new Promise(resolve => {
    localforage
      .removeItem(itemKey)
      .then(() => {
        resolve(true);
      })
      .catch(error => {
        errorCallback(error);
        resolve(false);
      });
  });

export const setItemToIndexedDB = (
  key,
  item,
  errorCallback = defaultErrorCallback
) =>
  new Promise(resolve => {
    localforage
      .setItem(key, item)
      .then(() => {
        resolve(true);
      })
      .catch(error => {
        errorCallback(error);
        resolve(false);
      });
  });

export const getKeysFromIndexedDB = (errorCallback = defaultErrorCallback) =>
  new Promise(resolve => {
    localforage
      .keys()
      .then(keys => {
        resolve(keys);
      })
      .catch(error => {
        errorCallback(error);
        resolve([]);
      });
  });

export const clearIndexedDBIfNeeded = (
  formState,
  errorCallback = defaultErrorCallback
) =>
  new Promise(resolve => {
    const handleError = error => {
      errorCallback(error);
      resolve(false);
    };

    getKeysFromIndexedDB(handleError).then(keys => {
      if (keys.length) {
        const shouldSave = keys.some(key => !!formState[key]);

        if (!shouldSave) {
          clearIndexedDB(handleError).then(() => {});
        }
      }

      resolve(true);
    });
  });
